/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Summary of victory points gained by the given corporation for the enlisted faction
 * @export
 * @interface GetCorporationsCorporationIdFwStatsVictoryPoints
 */
export interface GetCorporationsCorporationIdFwStatsVictoryPoints {
    /**
     * Last week's victory points gained by members of the given corporation
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsVictoryPoints
     */
    lastWeek: number;
    /**
     * Total victory points gained since the given corporation enlisted
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsVictoryPoints
     */
    total: number;
    /**
     * Yesterday's victory points gained by members of the given corporation
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsVictoryPoints
     */
    yesterday: number;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdFwStatsVictoryPoints interface.
 */
export function instanceOfGetCorporationsCorporationIdFwStatsVictoryPoints(value: object): value is GetCorporationsCorporationIdFwStatsVictoryPoints {
    if (!('lastWeek' in value) || value['lastWeek'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdFwStatsVictoryPointsFromJSON(json: any): GetCorporationsCorporationIdFwStatsVictoryPoints {
    return GetCorporationsCorporationIdFwStatsVictoryPointsFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsVictoryPointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdFwStatsVictoryPoints {
    if (json == null) {
        return json;
    }
    return {
        
        'lastWeek': json['last_week'],
        'total': json['total'],
        'yesterday': json['yesterday'],
    };
}

export function GetCorporationsCorporationIdFwStatsVictoryPointsToJSON(json: any): GetCorporationsCorporationIdFwStatsVictoryPoints {
    return GetCorporationsCorporationIdFwStatsVictoryPointsToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsVictoryPointsToJSONTyped(value?: GetCorporationsCorporationIdFwStatsVictoryPoints | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_week': value['lastWeek'],
        'total': value['total'],
        'yesterday': value['yesterday'],
    };
}

